/**
 * Component to redirect users to the email verification page
 */
import React from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';

const propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }).isRequired,
};

function VerifyEmailRedirect({ location }) {
  return (
    <Redirect
      to={{
        pathname: '/sign-up/verify-email',
        state: { from: location.pathname },
      }}
    />
  );
}

VerifyEmailRedirect.propTypes = propTypes;

export default VerifyEmailRedirect;
